import { useState } from 'react';
import { Box, Grid, TextField, Typography, Button, Alert, Fade } from '@mui/material';

const ContactForm = () => {
    const [form, setForm] = useState({ name: '', email: '', message: '' });
    const [submitted, setSubmitted] = useState(false);

    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();

        // Basic validation (can be expanded)
        if (!form.name || !form.email || !form.message) return;

        setSubmitted(true);
        setForm({ name: '', email: '', message: '' });

        // Here, you can send the data to an API or email service
    };

    return (
        <Box sx={{ mt: 8, px: { xs: 2, md: 6 }, maxWidth: 1200, mx: 'auto' }}>
            <Grid container spacing={6}>
                {/* LEFT SIDE: Info */}
                <Grid item xs={12} md={6}>
                    <Typography variant="h4" fontWeight={700} sx={{ mb: 2, color: '#777' }}>
                        Can We Help?
                    </Typography>
                    <Typography sx={{ mb: 2 }}>
                        Our boutiques are carefully curated, selected for their deep understanding of materials, craftsmanship, and their love for fashion. Whether you’re exploring our online store or visiting us in person, we’re always happy to offer expert advice and share our passion for the products and designs we offer.
                    </Typography>
                    <Typography>
                        For answers to common inquiries, please refer to our <strong>FAQ</strong> section. Or reach out by completing the form or email us at <strong>{`support@${window.location.hostname}`}</strong>.
                    </Typography>
                </Grid>

                {/* RIGHT SIDE: FORM */}
                <Grid item xs={12} md={6}>
                    <Fade in={submitted}>
                        <Alert severity="success" sx={{ mb: 3 }}>
                            We’ve received your message and will get back to you shortly.
                        </Alert>
                    </Fade>

                    <Box component="form" onSubmit={handleSubmit}>
                        <TextField
                            fullWidth
                            label="Name"
                            name="name"
                            value={form.name}
                            onChange={handleChange}
                            sx={{ mb: 2 }}
                            required
                        />
                        <TextField
                            fullWidth
                            type="email"
                            label="Email"
                            name="email"
                            value={form.email}
                            onChange={handleChange}
                            sx={{ mb: 2 }}
                            required
                        />
                        <TextField
                            fullWidth
                            label="Message"
                            name="message"
                            multiline
                            rows={4}
                            value={form.message}
                            onChange={handleChange}
                            sx={{ mb: 3 }}
                            required
                        />
                        <Button
                            type="submit"
                            fullWidth
                            variant="contained"
                            sx={{
                                textTransform: 'none',
                                fontWeight: 600,
                                bgcolor: '#333',
                                '&:hover': {
                                    bgcolor: '#111'
                                }
                            }}
                        >
                            Send
                        </Button>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default ContactForm;
